import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full justify-center" }
const _hoisted_2 = { class: "m-auto flex flex-col items-center" }
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = { class: "text-5xl sm:text-7xl m-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-light text-gray-800 mt-1 mb-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Find. Explore. Analyse. Science.")
], -1)
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg pt-10 text-gray-400" }, "or start with one of our examples", -1)
const _hoisted_8 = { class: "grid grid-cols-2 lg:grid-cols-5 gap-8 pt-2" }
const _hoisted_9 = { class: "fixed bottom-1 right-2 w-full flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_standard_logo = _resolveComponent("standard-logo")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_ExampleTile = _resolveComponent("ExampleTile")!
  const _component_PrivacyPolicyImprintLinks = _resolveComponent("PrivacyPolicyImprintLinks")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_standard_logo)
          ]),
          _hoisted_5,
          _createVNode(_component_SearchBar, { class: "py-4" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examples, (example, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createVNode(_component_ExampleTile, {
                  title: example.title,
                  searchQuery: example.searchQuery,
                  imgSrc: example.imgSrc
                }, null, 8, ["title", "searchQuery", "imgSrc"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_PrivacyPolicyImprintLinks)
    ])
  ], 64))
}